export enum TestOpsUserSsoInvitationStatus {
  PENDING = 'PENDING',
  ACTIVE = 'ACTIVE',
  DECLINED = 'DECLINED',
  DELETED = 'DELETED',
}
